import { buildClient } from '../utils/url';
var centralService = {
    baseUrl: {
        SERVICE: 'central',
        API_INTEGRATIONS: 'api-integrations',
        AUDIT_EVENTS: 'audit-events',
        ASSUMPTIONS: 'assumptions',
        BUSINESS_UNITS: 'business-units',
        CHANGELOGS: 'changelogs',
        CONFIG_VIEWS: 'config-views',
        CUSTOMERS: 'customers',
        FILES: 'files',
        LOCATIONS: 'locations',
        NOTIFICATIONS: 'notifications',
        ORGANIZATIONS: 'organizations',
        PRODUCTS: 'products',
        PRODUCT_TAGS: 'product-tags',
        ROLES: 'roles',
        SUBSCRIPTIONS: 'subscriptions',
        SUPPLIERS: 'suppliers',
        USER_FUNCTIONS: 'user-functions',
        USERS: 'users',
        VIEWS: 'views',
    },
    apiIntegrations: {
        GET_MANY: '/',
        GET_CONFIGURATION: '/configuration/:id',
        GET_CONFIGURATIONS: '/configurations/:integrationKey',
        CONFIGURE: '/:id/configure',
        CREATE_TRANSACTION: '/:id/transactions',
        UPDATE_TRANSACTION: '/:id/transactions/:transactionId',
        CHECK_CONNECTION: '/:id/check-connection',
        MANUAL_IMPORT: '/:id/import',
    },
    assumptions: {
        GET_MANY: '/',
    },
    auditEvents: {
        GET_MANY: '/',
        CREATE: '/',
    },
    businessUnits: {
        SEARCH: '/search',
        GET_SCOPE: '/scope',
        VALIDATE_ACCESS: '/validate',
        TRANSFER: '/:id/transfer/:parentId',
        GET_ONE: '/:id',
        GET_ANCESTRY: '/ancestry',
        GET_ANCESTRY_IDS: '/ancestry-ids',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        EXTERNAL_TRANSFER: '/external/:externalId/transfer/:parentExternalId',
        EXTERNAL_GET_MANY: '/external/',
        EXTERNAL_GET_ONE: '/external/:externalId',
        EXTERNAL_CREATE: '/external/',
        EXTERNAL_UPDATE_ONE: '/external/:externalId',
        EXTERNAL_DELETE_ONE: '/external/:externalId',
        COUNT: '/count',
        GET_VALID_IDS: '/valid-ids',
        GET_ORGANIGRAM: '/:id/organigram',
        GET_CHILDREN_IDS: '/:id/children-ids',
    },
    changelogs: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        GET_LOG: '/log',
    },
    configViews: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    customers: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    files: {
        GET_CATEGORY_IMAGE: '/category',
        GET_ONE: '/logo/:id',
    },
    locations: {
        GET_ADDRESS: '/addresses',
        SEARCH: '/search',
        GET_ONE_WITH_LOG_OVERVIEW: '/:id/log-overview',
        VALIDATE: '/validate',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        EXTERNAL_GET_MANY: '/external/',
        EXTERNAL_GET_ONE: '/external/:externalId',
        EXTERNAL_CREATE: '/external/',
        EXTERNAL_UPDATE_ONE: '/external/:externalId',
        EXTERNAL_DELETE_ONE: '/external/:externalId',
        GET_BY_IDS: '/ids',
        COUNT: '/count',
    },
    notifications: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    organizations: {
        GET_ONE: '/:id',
        GET_ME: '/me',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        UPDATE_ME: '/me',
        GET_USAGE: '/usage',
        SIGNED_PUT_IMAGE_URL: '/signed-put-image-url',
        INCREMENT_USAGE: '/:id/increment-api-usage',
        GET_API_USAGE: '/api-usage',
    },
    products: {
        SEARCH: '/search',
        GET_DATA: '/data',
        VALIDATE: '/validate',
        GET_ONE_WITH_LOG_OVERVIEW: '/:id/log-overview',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        TRANSFER: '/:id/transfer',
        DUPLICATE: '/:id/duplicate',
        EXTERNAL_GET_MANY: '/external/',
        EXTERNAL_GET_ONE: '/external/:externalId',
        ORGANIZATION_TOTAL_PRODUCT_EMISSIONS: '/organization-total-product-emissions',
        EXTERNAL_CREATE: '/external/',
        EXTERNAL_UPDATE_ONE: '/external/:externalId',
        EXTERNAL_DELETE_ONE: '/external/:externalId',
        GET_BY_IDS: '/ids',
        COUNT: '/count',
        PRODUCT_TYPES: '/product-types',
        SIGNED_PUT_PRODUCT_CONFIGURATION_URL: '/signed-put-product-configuration-url',
    },
    productTags: {
        GET_MANY: '/',
        CREATE: '/',
        DELETE_ONE: '/:id',
        GET_ONE: '/:id',
    },
    roles: {
        GET_MANY: '/',
        GET_ONE: '/:id',
    },
    subscriptions: {
        GET_ACTIVE: '/',
        GET_SALES_CALENDAR: '/sales-calendar',
        GET_CUSTOMER_PORTAL: '/customer-portal',
        GET_CHECKOUT_URL: '/checkout',
        STRIPE_WEBHOOK: '/webhook',
        GET_PRODUCTS: '/products',
        GET_CHECKOUT_SESSION: '/sessions/:id',
        CONTACT_SALES: '/sales',
    },
    userFunctions: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    users: {
        GET_ME: '/me',
        GET_ONE: '/:id',
        UPDATE_ONE: '/:id',
        UPDATE_ME: '/me',
        DELETE_ONE: '/:id',
        SEND_MAGIC_LINK: '/:id/send-magic-link',
        GET_USER_BY_EMAIL: '/email',
        COMPARE_PASSWORD: '/password',
        SEARCH: '/search',
        EXPORT: '/export',
        SEARCH_FILTER_BY_BU: '/search/filter-business-unit',
        INVITE: '/:id/invite',
        CREATE_AND_INVITE: '/',
        GET_NOTIFICATION_CONFIGURATION: '/notification-configuration',
        REQUEST_PASSWORD: '/password/request',
        PASSWORD_RESET: '/password/reset',
        START_REGISTRATION: '/register/start',
        REGISTER_PROFILE: '/register/profile',
        INVITE_SUPPLIER: '/invite/supplier',
        CREATE_SUPPLIER: '/create/supplier',
        EXTERNAL_GET_ONE: '/external/:externalId',
        EXTERNAL_UPDATE_ONE: '/external/:externalId',
        EXTERNAL_DELETE_ONE: '/external/:externalId',
        GET_BY_IDS: '/ids',
        DISABLE_ONBOARDING: '/disable-onboarding',
        CHANGE_PASSWORD: '/password',
        UPDATE_ONBOARDING: '/onboarding',
        SIGNED_PUT_IMAGE_URL: '/signed-put-image-url',
        COUNT: '/count',
    },
    suppliers: {
        CREATE: '/',
        UPDATE_ONE: '/:id',
        GET_FACTOR_REQUESTS: '/factor-requests',
        GET_MANY: '/',
        GET_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    views: {
        INITIALIZE_LOG_OVERVIEW: '/log',
    },
};
var centralServiceClient = {
    apiIntegrations: buildClient(centralService.baseUrl.API_INTEGRATIONS, centralService.apiIntegrations),
    auditEvents: buildClient(centralService.baseUrl.AUDIT_EVENTS, centralService.auditEvents),
    assumptions: buildClient(centralService.baseUrl.ASSUMPTIONS, centralService.assumptions),
    businessUnits: buildClient(centralService.baseUrl.BUSINESS_UNITS, centralService.businessUnits),
    changelogs: buildClient(centralService.baseUrl.CHANGELOGS, centralService.changelogs),
    configViews: buildClient(centralService.baseUrl.CONFIG_VIEWS, centralService.configViews),
    customers: buildClient(centralService.baseUrl.CUSTOMERS, centralService.customers),
    files: buildClient(centralService.baseUrl.FILES, centralService.files),
    locations: buildClient(centralService.baseUrl.LOCATIONS, centralService.locations),
    notifications: buildClient(centralService.baseUrl.NOTIFICATIONS, centralService.notifications),
    organizations: buildClient(centralService.baseUrl.ORGANIZATIONS, centralService.organizations),
    products: buildClient(centralService.baseUrl.PRODUCTS, centralService.products),
    productTags: buildClient(centralService.baseUrl.PRODUCT_TAGS, centralService.productTags),
    roles: buildClient(centralService.baseUrl.ROLES, centralService.roles),
    subscriptions: buildClient(centralService.baseUrl.SUBSCRIPTIONS, centralService.subscriptions),
    suppliers: buildClient(centralService.baseUrl.SUPPLIERS, centralService.suppliers),
    userFunctions: buildClient(centralService.baseUrl.USER_FUNCTIONS, centralService.userFunctions),
    users: buildClient(centralService.baseUrl.USERS, centralService.users),
    views: buildClient(centralService.baseUrl.VIEWS, centralService.views),
};
var centralApiGatewayClient = {
    apiIntegrations: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.API_INTEGRATIONS), centralService.apiIntegrations),
    auditEvents: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.AUDIT_EVENTS), centralService.auditEvents),
    assumptions: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.ASSUMPTIONS), centralService.assumptions),
    businessUnits: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.BUSINESS_UNITS), centralService.businessUnits),
    changelogs: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.CHANGELOGS), centralService.changelogs),
    configViews: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.CONFIG_VIEWS), centralService.configViews),
    customers: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.CUSTOMERS), centralService.customers),
    files: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.FILES), centralService.files),
    locations: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.LOCATIONS), centralService.locations),
    notifications: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.NOTIFICATIONS), centralService.notifications),
    organizations: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.ORGANIZATIONS), centralService.organizations),
    products: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.PRODUCTS), centralService.products),
    productTags: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.PRODUCT_TAGS), centralService.productTags),
    roles: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.ROLES), centralService.roles),
    subscriptions: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.SUBSCRIPTIONS), centralService.subscriptions),
    suppliers: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.SUPPLIERS), centralService.suppliers),
    userFunctions: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.USER_FUNCTIONS), centralService.userFunctions),
    users: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.USERS), centralService.users),
    views: buildClient("".concat(centralService.baseUrl.SERVICE, "/").concat(centralService.baseUrl.VIEWS), centralService.views),
};
export { centralService, centralServiceClient, centralApiGatewayClient };
//# sourceMappingURL=central-service.js.map